import { BitpieWalletAdapter } from '@solana/wallet-adapter-bitpie';
import { Coin98WalletAdapter } from '@solana/wallet-adapter-coin98';
import { LedgerWalletAdapter } from '@solana/wallet-adapter-ledger';
import { MathWalletWalletAdapter } from '@solana/wallet-adapter-mathwallet';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-phantom';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import { SolletWalletAdapter } from '@solana/wallet-adapter-sollet';
import { SolongWalletAdapter } from '@solana/wallet-adapter-solong';
import { TorusWalletAdapter } from '@solana/wallet-adapter-torus';
export var WalletName;
(function (WalletName) {
    WalletName["Bitpie"] = "Bitpie";
    WalletName["Coin98"] = "Coin98";
    WalletName["Ledger"] = "Ledger";
    WalletName["MathWallet"] = "MathWallet";
    WalletName["Phantom"] = "Phantom";
    WalletName["Solflare"] = "Solflare";
    WalletName["SolflareWeb"] = "Solflare (Web)";
    WalletName["Sollet"] = "Sollet";
    WalletName["Solong"] = "Solong";
    WalletName["Torus"] = "Torus";
})(WalletName || (WalletName = {}));
export const ICONS_URL = 'https://raw.githubusercontent.com/solana-labs/wallet-adapter/master/packages/wallets/icons';
export const getBitpieWallet = (config) => ({
    name: WalletName.Bitpie,
    url: 'https://bitpiecn.com',
    icon: `${ICONS_URL}/bitpie.svg`,
    adapter: () => new BitpieWalletAdapter(config),
});
export const getCoin98Wallet = (config) => ({
    name: WalletName.Coin98,
    url: 'https://coin98.com',
    icon: `${ICONS_URL}/coin98.svg`,
    adapter: () => new Coin98WalletAdapter(config),
});
export const getLedgerWallet = (config) => ({
    name: WalletName.Ledger,
    url: 'https://www.ledger.com',
    icon: `${ICONS_URL}/ledger.svg`,
    adapter: () => new LedgerWalletAdapter(config),
});
export const getMathWallet = (config) => ({
    name: WalletName.MathWallet,
    url: 'https://mathwallet.org',
    icon: `${ICONS_URL}/mathwallet.svg`,
    adapter: () => new MathWalletWalletAdapter(config),
});
export const getPhantomWallet = (config) => ({
    name: WalletName.Phantom,
    url: 'https://www.phantom.app',
    icon: `${ICONS_URL}/phantom.svg`,
    adapter: () => new PhantomWalletAdapter(config),
});
export const getSolflareWallet = (config) => ({
    name: WalletName.Solflare,
    url: 'https://solflare.com',
    icon: `${ICONS_URL}/solflare.svg`,
    adapter: () => new SolflareWalletAdapter(config),
});
export const getSolflareWebWallet = (config) => ({
    name: WalletName.SolflareWeb,
    url: 'https://solflare.com',
    icon: `${ICONS_URL}/solflare.svg`,
    adapter: () => new SolletWalletAdapter(Object.assign(Object.assign({}, config), { provider: (config === null || config === void 0 ? void 0 : config.provider) || 'https://solflare.com/access-wallet' })),
});
export const getSolletWallet = (config) => ({
    name: WalletName.Sollet,
    url: 'https://www.sollet.io',
    icon: `${ICONS_URL}/sollet.svg`,
    adapter: () => new SolletWalletAdapter(config),
});
export const getSolongWallet = (config) => ({
    name: WalletName.Solong,
    url: 'https://solongwallet.com',
    icon: `${ICONS_URL}/solong.png`,
    adapter: () => new SolongWalletAdapter(config),
});
export const getTorusWallet = (config) => ({
    name: WalletName.Torus,
    url: 'https://tor.us',
    icon: `${ICONS_URL}/torus.svg`,
    adapter: () => new TorusWalletAdapter(config),
});
//# sourceMappingURL=wallets.js.map